import React, { createContext, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { logUserAction } from './userLogging';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();

    const login = (token) => {
        localStorage.setItem('authToken', token);
        logUserAction('Login', '', '', '', '', '', '', '', '', '', '', '');

        // const competitionEntered = localStorage.getItem('competitionEntered');
        // if (competitionEntered) {
        //     navigate('/global-landing-page')
        // } else {
        //     navigate("/global-competition-page");
        // }

        navigate("/global-competition-page");
    };

    const logout = () => {
        localStorage.removeItem('authToken');
        navigate('/');
    };

    return (
        <AuthContext.Provider value={{ login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
